$('.coustom-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    autoplay: true, 
    loop:true, 
    prevArrow:'<div class="slick_arrows prev-arrow"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg></div>',
    nextArrow:'<div class="slick_arrows next-arrow"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>'
  });

document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
console.log(lazyVideos);
  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

$(document).on('click','.only_desktop .cstm_seemore' , function(){
   $(this).closest('.only_desktop').find('.only_desktop_show').slideToggle();
   if ($(this).closest('.only_desktop').find('.cstm_seemore').text() == "Read More") {
     $(this).closest('.only_desktop').find('.only_desktop_description').hide();
      $(this).text("Read Less")
      } else {
      $(this).text("Read More")
       $(this).closest('.only_desktop').find('.only_desktop_description').show();
      }
    });
